import { useState } from 'react';
import { Alert, Text } from '@hopskipdrive/react-components';

import { FindSuggestionsButton } from './FindSuggestionsButton';
import { BannerContainer } from './styles';

export const SmartPoolingBanner = ({ handleFindSuggestions }) => {
  const [open, setOpen] = useState(true);

  return open ? (
    <Alert
      data-testid="smart-pooling-banner"
      aria-label="smart pooling banner"
      variant="standard"
      onClose={() => setOpen(false)}
      severity={'info'}
      title="Save up to 45% with SmartPooling!"
      message={
        <BannerContainer>
          <Text textColor="secondary">
            {
              'Save on fares by adding multiple riders to the same ride! Also, RideIQ now offers you existing rides that match the new route you’re setting up. Try it out!'
            }
          </Text>
          <FindSuggestionsButton onClick={handleFindSuggestions} />
        </BannerContainer>
      }
      sx={{ mb: '12px' }}
    />
  ) : null;
};
